import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import DialogListItem from './DialogListItem';
export default class DialogList extends Component {
  view() {
    const state = this.attrs.state;
    return m("div", {
      className: "DialogList"
    }, m("ul", {
      className: "DialogList-list"
    }, state.getAllItems().map(dialog => m(DialogListItem, {
      key: dialog.id(),
      dialog: dialog,
      active: this.attrs.activeDialog?.id() === dialog.id(),
      actions: this.attrs.itemActions
    }))), state.hasNext() && !this.attrs.hideMore && m("div", {
      className: "DialogList-loadMore"
    }, m(Button, {
      className: "Button",
      loading: state.isLoadingNext(),
      disabled: state.isLoadingNext(),
      onclick: () => state.loadNext()
    }, app.translator.trans('flarum-messages.forum.dialog_list.load_more_button'))));
  }
}
flarum.reg.add('flarum-messages', 'forum/components/DialogList', DialogList);